import React from 'react';
import { useSelector } from 'react-redux';
import { createProductIntegrationOptions } from 'store/schema/helpers';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import { SelectInput } from 'components';

const useStyles = makeStyles(() => ({
  inputGrid: {
    maxWidth: '100rem'
  }
}));

const ProductIntegrationOptions = props => {
  const { schema } = props;
  const schemaDetails = useSelector(store => store.schema.currentDetails);
  const eventTypes = useSelector(store => store.schema.eventTypes);
  const {
    handleOptionsChange,
    handleBlur,
    shouldShowError,
    getErrorMessage
  } = schema;
  const classes = useStyles();
  const {
    productCategoryAndNames,
    productNamesAndEventType
  } = createProductIntegrationOptions(eventTypes);

  const getEventTypeOptions = () => {
    let options = [];
    Object.keys(productCategoryAndNames).forEach(productCategory =>
      productCategoryAndNames[productCategory].map(productName =>
        productNamesAndEventType[productName].map(option =>
          options.push({
            value: productCategory + ' - ' + productName + ' - ' + option
          })
        )
      )
    );
    return {
      list: options,
      keyId: 'value',
      valueId: 'value',
      displayValueId: 'value'
    };
  };

  return (
    <div className={classes.root}>
      <Grid item md={6} xs={12}>
        <Grid item xs={12} className={classes.inputGrid}>
          <SelectInput
            fullWidth
            required
            margin="dense"
            name="productIntegrationOptions"
            label="Integrating Products"
            value={schemaDetails.option || ''}
            disabled={schemaDetails.hasMovedToNextStep}
            onBlur={handleBlur}
            onChange={handleOptionsChange}
            error={shouldShowError('option')}
            helperText={getErrorMessage('option')}
            options={getEventTypeOptions()}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default ProductIntegrationOptions;
